import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import type { EstimateMode } from '@/lib/estimate';

interface EstimateModeContextValue {
  mode: EstimateMode;
  setMode: (m: EstimateMode) => void;
}

const EstimateModeContext = createContext<EstimateModeContextValue | undefined>(undefined);
const STORAGE_KEY = 'aima.estimateMode';

function readInitialMode(): EstimateMode {
  if (typeof window === 'undefined') return 'expected';
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === 'optimistic' || stored === 'expected' || stored === 'pessimistic') return stored;
  return 'expected';
}

export function EstimateModeProvider({ children }: { children: ReactNode }) {
  const [mode, setMode] = useState<EstimateMode>(readInitialMode);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, mode);
  }, [mode]);

  return (
    <EstimateModeContext.Provider value={{ mode, setMode }}>{children}</EstimateModeContext.Provider>
  );
}

export function useEstimateMode(): EstimateModeContextValue {
  const ctx = useContext(EstimateModeContext);
  if (!ctx) throw new Error('useEstimateMode must be used inside <EstimateModeProvider>');
  return ctx;
}
